import React from 'react';
import 'moment/locale/zh-cn';
import 'babel-polyfill';
import "antd/dist/antd.css";
import {Layout} from 'antd';
import Navigate from "./containers/navigate.js";
import PmsNavigateLevel1 from "./containers/pmsNavigate.js";
import Header from "./containers/header";
import {connect} from "react-redux";
import {PmsNavigateLevel2} from "./containers/pmsNavigate";
import {NAVIGATE_CLOSE, NAVIGATE_LEVEN2_ENABLE, NAVIGATE_OPEN} from "./constants";
import BaseComponent from "./base/BaseComponent";
const { Sider } = Layout;

class App extends BaseComponent{

    constructor(props) {
        super(props);
        this.state={
        }
    }

    getNavigate(){
       // console.log( applicationName() === "pms");
        if(NAVIGATE_LEVEN2_ENABLE){
            return <PmsNavigateLevel1 />
        }else{
            return <Navigate />
        }
    }

    getNavigateLevel2(){
        if(this.isNewMenu==='1' || NAVIGATE_LEVEN2_ENABLE){
            return <div  key={new Date().getTime()}>  <PmsNavigateLevel2 /></div>
        }
    }
    componentWillReceiveProps(nextProps, nextContext) {
       this.setState({})
    }


    isNewMenu = '1';
    render() {
        //新增动态获取-----------
        let {config} = this.getInfo();
        this.isNewMenu = config&&config.getValueByKey?config.getValueByKey("NewMenu", '1'):'1';
        let bgColor = config&&config.getValueByKey?config.getValueByKey("NewMenuBg", '#0050B3'):'#0050B3';
        let clientWidth = window.document.body.clientWidth;
        let contentMarginScopeDefault = '[{"expression":">=1900","value":"140"},{"expression":"<1900","value":"40"}]';
        let contentMarginScope = config&&config.getValueByKey?config.getValueByKey("system.content.margin.scope", contentMarginScopeDefault):contentMarginScopeDefault;
        contentMarginScope = JSON.parse(contentMarginScope);
        let contentMarginValue = 40;
        for(let i = 0; i < contentMarginScope.length; i++){
            let contentMargin = contentMarginScope[i];
            let isTrue = eval(clientWidth + contentMargin.expression);
            if(isTrue){
                contentMarginValue = parseInt(contentMargin.value);
                break;
            }
        }


        const AntdHeader = Layout.Header;
        //枚举递增为了解决以后菜单累计问题
        switch (this.isNewMenu) {
            case '0':
                return (
                    <Layout style={{height: "100%"}}>
                        <Sider style={{background: "#0855A5", float: "left"}}
                               width={(this.props.navigateStatus ? NAVIGATE_OPEN : NAVIGATE_CLOSE)}>
                            {this.getNavigate()}
                        </Sider>
                        <Layout>
                            <Header isNewMenu={this.isNewMenu}/>
                            <div>
                                {this.getNavigateLevel2()}
                                {this.props.refersh ? React.cloneElement(this.props.content) : this.props.content}
                            </div>
                        </Layout>
                    </Layout>
                );
                break;
            case '1':
                return (
                    <Layout style={{height: "100%"}}>
                        <div className={'header'} style={{height:71,position:'relative',boxShadow: '2px 4px 6px rgba(208, 208, 208, 0.4)',
                            WebkitBoxShadow:'2px 4px 6px rgba(208, 208, 208, 0.4)',
                            MozBoxShadow:'2px 4px 6px rgba(208, 208, 208, 0.4)'
                        }} >
                        <AntdHeader style={{padding: "0px"}}>
                            <Header isNewMenu={this.isNewMenu} bgColor={bgColor}/>
                        </AntdHeader></div>
                        <Layout>
                            <div className={'antContent'} style={{marginLeft:contentMarginValue,marginRight:contentMarginValue}}>
                                {this.getNavigateLevel2()}
                                {this.props.refersh ? React.cloneElement(this.props.content) : this.props.content}
                            </div>
                        </Layout>
                    </Layout>
                );
                break;
            default:
                return (
                    <Layout style={{height: "100%"}}>
                        <Sider style={{background: "#0855A5", float: "left"}}
                               width={(this.props.navigateStatus ? NAVIGATE_OPEN : NAVIGATE_CLOSE)}>
                            {this.getNavigate()}
                        </Sider>
                        <Layout>
                            <Header isNewMenu={this.isNewMenu}/>
                            <div>
                                {this.getNavigateLevel2()}
                                {this.props.refersh ? React.cloneElement(this.props.content) : this.props.content}
                            </div>
                        </Layout>
                    </Layout>
                );

        }
    }
}

function mapStateToProps(state){
    return {
        navigateStatus: state.systemReducer.navigateStatus,
        refersh: state.systemReducer.refersh,
    }
}
export default connect(mapStateToProps)(App);
